'use client';

import { useQuery } from '@tanstack/react-query';
import { getCategories } from '@/lib/api/products';
import type { Category } from '@/types';

// Query keys
export const categoryKeys = {
  all: ['categories'] as const,
  lists: () => [...categoryKeys.all, 'list'] as const,
  detail: (id: number) => [...categoryKeys.all, 'detail', id] as const,
};

/**
 * Hook to fetch all categories
 */
export function useCategories(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: categoryKeys.lists(),
    queryFn: getCategories,
    staleTime: 10 * 60 * 1000, // 10 minutes
    gcTime: 60 * 60 * 1000, // 1 hour
    ...options,
  });
}

/**
 * Get category by ID from list
 */
export function getCategoryById(
  categories: Category[] | undefined,
  id: number
): Category | undefined {
  return categories?.find((category) => category.id === id);
}

/**
 * Sort categories by sort_order
 */
export function sortCategories(categories: Category[]): Category[] {
  return [...categories].sort((a, b) => a.sort_order - b.sort_order);
}

/**
 * Filter visible categories only
 */
export function getVisibleCategories(categories: Category[]): Category[] {
  return categories.filter((category) => category.is_visible);
}

